import type { Prismic } from '@landsbankinn/prismic';
import { isEmptyText, PrismicText } from '@landsbankinn/prismic';
import { Segment } from '@landsbankinn/ui';
import React from 'react';
import { Img } from '../components/img/Img';
import { TextWithImage } from '../components/slices/TextWithImage';

interface IProps {
  copy: Prismic.RichText;
  image: Prismic.Image;
  align: string;
  template: string;
}

export const TextWithImageContainer = ({ copy, image, template }: IProps) => {
  if (isEmptyText(copy)) {
    return null;
  }
  const isArticle = template === 'article';
  const imgHeight = image?.aside?.dimensions.height;
  const imgWith = image?.aside?.dimensions.width;
  const imgRatio = (imgWith ?? 4) / (imgHeight ?? 3);

  return (
    <Segment isArticle={isArticle}>
      <TextWithImage
        images={<Img src={image} ar="aside" aspectRatio={imgRatio} />}
        isArticle={isArticle}
      >
        <PrismicText value={copy} isArticle={isArticle} />
      </TextWithImage>
    </Segment>
  );
};
